import { Component, Inject } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { TradeTypeModel } from '../../../interfaces/trade-types/trade-type.model';
import { ISelectList } from '../../../shared/models/select-list.model';
import { MessageService } from '../../../shared/services/message/message.service';
import { TradeTypeListService } from '../../../shared/services/trade-types/trade-type-list.service';
import { GatekeeperModalComponent } from '../../modal.component';

@Component({
  selector: 'gk-save-trade-type-modal',
  templateUrl: './save-trade-type-modal.html'
})
export class SaveTradeTypeModalComponent extends GatekeeperModalComponent<SaveTradeTypeModalComponent> {
  saveTradeTypeForm: UntypedFormGroup;
  public tradingTypeList: Array<ISelectList> = [];
  public addAnother: boolean;
  public tradeType: TradeTypeModel;

  constructor(
    private messageService: MessageService,
    private tradeTypeListService: TradeTypeListService,
    public dialogRef: MatDialogRef<SaveTradeTypeModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();

    this.tradingTypeList = data.locals.tradingTypeList;
    this.addAnother = data.locals.addAnother;
    this.tradeType = data.locals.tradeType;
  }

  saveTradeType() {
    return this.tradeType.id ? this.updateTradeType() : this.addTradeType();
  }

  addTradeType(): Promise<any> {
    return this.tradeTypeListService
      .addTradeType(this.tradeType)
      .then(() => {
        this.messageService.showIcon(MessageTypeEnum.Success);
        this.dialogRef.close(this.addAnother);
      })
      .catch(() => {
        this.messageService.showMessage(
          MessageTypeEnum.Danger,
          'TRADE_TYPE_SAVE_ERROR'
        );
      });
  }

  updateTradeType(): Promise<any> {
    return this.tradeTypeListService
      .updateTradeType(this.tradeType)
      .then(() => {
        this.messageService.showIcon(MessageTypeEnum.Success);
        this.dialogRef.close(this.addAnother);
      })
      .catch(() =>
        this.messageService.showMessage(
          MessageTypeEnum.Danger,
          'TRADE_TYPE_SAVE_ERROR'
        )
      );
  }
}
